import { VEHICLES } from './vehicles';

// 10/07/2026 — helpers pour les nouveaux challenges.
const countElectricVehicles = (s) => (s.vehicles || []).filter(v => {
  const base = VEHICLES.find(c => c.id === v.dataId);
  return (v.engineType || base?.engineType) === 'electric';
}).length;

const avgDriverSatisfaction = (s) => {
  const drivers = s.drivers || [];
  if (drivers.length === 0) return 0;
  return Math.round(drivers.reduce((sum, d) => sum + (d.satisfaction || 0), 0) / drivers.length);
};

export const CHALLENGES = [
  {
    id: 'ch-100k-6m',
    name: 'L\'Ambitieux',
    description: 'Atteignez 100 000 \u20ac de tr\u00e9sorerie en 6 mois.',
    difficulty: 'normal',
    icon: 'trophy',
    color: 'from-amber-500 to-amber-600',
    timeLimitDays: 180,
    objectives: [
      { id: 'treasury', label: 'Tr\u00e9sorerie \u2265 100 000 \u20ac', check: (s) => s.treasury >= 100000, target: 100000, current: (s) => s.treasury, format: 'money' },
    ],
    reward: '+ Badge "L\'Ambitieux" d\u00e9bloqu\u00e9',
  },
  {
    id: 'ch-5trucks-3m',
    name: 'Bâtisseur de flotte',
    description: 'Poss\u00e9dez 5 v\u00e9hicules en 3 mois.',
    difficulty: 'facile',
    icon: 'truck',
    color: 'from-blue-500 to-blue-600',
    timeLimitDays: 90,
    objectives: [
      { id: 'vehicles', label: '5 v\u00e9hicules dans la flotte', check: (s) => s.vehicles.length >= 5, target: 5, current: (s) => s.vehicles.length, format: 'number' },
    ],
    reward: '+ Badge "B\u00e2tisseur" d\u00e9bloqu\u00e9',
  },
  {
    id: 'ch-rep90-1y',
    name: 'L\'Excellence',
    description: 'Atteignez une r\u00e9putation de 90 en 1 an.',
    difficulty: 'difficile',
    icon: 'star',
    color: 'from-purple-500 to-purple-600',
    timeLimitDays: 365,
    objectives: [
      { id: 'reputation', label: 'R\u00e9putation \u2265 90', check: (s) => s.reputation >= 90, target: 90, current: (s) => Math.round(s.reputation), format: 'number' },
    ],
    reward: '+ Badge "Excellence" d\u00e9bloqu\u00e9',
  },
  {
    id: 'ch-empire',
    name: 'L\'Empire',
    description: '10 v\u00e9hicules, 8 chauffeurs, 200k\u20ac en 12 mois.',
    difficulty: 'difficile',
    icon: 'crown',
    color: 'from-red-500 to-red-600',
    timeLimitDays: 365,
    objectives: [
      { id: 'vehicles', label: '10 v\u00e9hicules', check: (s) => s.vehicles.length >= 10, target: 10, current: (s) => s.vehicles.length, format: 'number' },
      { id: 'drivers', label: '8 chauffeurs', check: (s) => s.drivers.length >= 8, target: 8, current: (s) => s.drivers.length, format: 'number' },
      { id: 'treasury', label: '200 000 \u20ac de tr\u00e9sorerie', check: (s) => s.treasury >= 200000, target: 200000, current: (s) => s.treasury, format: 'money' },
    ],
    reward: '+ Badge "Empereur du transport" d\u00e9bloqu\u00e9',
  },
  {
    id: 'ch-frugal',
    name: 'Le Frugal',
    description: 'Atteignez la Phase 3 sans jamais d\u00e9passer 3 v\u00e9hicules.',
    difficulty: 'difficile',
    icon: 'zap',
    color: 'from-emerald-500 to-emerald-600',
    timeLimitDays: 365,
    objectives: [
      { id: 'phase3', label: 'Phase 3 atteinte', check: (s) => s.phase >= 3, target: 3, current: (s) => s.phase, format: 'number' },
      { id: 'max3vehicles', label: 'Max 3 v\u00e9hicules (contrainte)', check: (s) => s.vehicles.length <= 3, target: 3, current: (s) => s.vehicles.length, format: 'constraint' },
    ],
    reward: '+ Badge "Le Frugal" d\u00e9bloqu\u00e9',
  },

  // ─────────────────────────────────────────────────────────────────
  // 10/07/2026 — retour user prod : « pas assez de challenges ».
  // 10 nouveaux défis couvrant les mécaniques récentes (dépôts, M&A,
  // international, AO, RH, flotte verte, financement).
  // ─────────────────────────────────────────────────────────────────
  {
    id: 'ch-network-3dep',
    name: 'Maillage territorial',
    description: 'Exploitez 3 dépôts (siège inclus) en 2 ans.',
    difficulty: 'normal',
    icon: 'building',
    color: 'from-cyan-500 to-cyan-600',
    timeLimitDays: 720,
    objectives: [
      { id: 'depots', label: '3 dépôts en exploitation', check: (s) => (s.ownedDepots || []).length >= 3, target: 3, current: (s) => (s.ownedDepots || []).length, format: 'number' },
    ],
    reward: '+ Badge "Bâtisseur de réseau" débloqué',
  },
  {
    id: 'ch-ma-predator',
    name: 'Le Prédateur',
    description: 'Rachetez un concurrent en 18 mois.',
    difficulty: 'difficile',
    icon: 'handshake',
    color: 'from-rose-500 to-rose-600',
    timeLimitDays: 540,
    objectives: [
      { id: 'ma', label: '1 concurrent racheté', check: (s) => (s.acquiredCompetitorIds || []).length >= 1, target: 1, current: (s) => (s.acquiredCompetitorIds || []).length, format: 'number' },
    ],
    reward: '+ Badge "Le Prédateur" débloqué',
  },
  {
    id: 'ch-phase4-2y',
    name: 'Sans frontières',
    description: 'Atteignez la phase 4 (International) en 2 ans.',
    difficulty: 'difficile',
    icon: 'globe',
    color: 'from-indigo-500 to-indigo-600',
    timeLimitDays: 720,
    objectives: [
      { id: 'phase', label: 'Phase 4 atteinte', check: (s) => (s.phase || 1) >= 4, target: 4, current: (s) => s.phase || 1, format: 'number' },
    ],
    reward: '+ Badge "Sans frontières" débloqué',
  },
  {
    id: 'ch-green-fleet',
    name: 'Flotte verte',
    description: 'Possédez 2 véhicules électriques en 18 mois.',
    difficulty: 'normal',
    icon: 'leaf',
    color: 'from-green-500 to-green-600',
    timeLimitDays: 540,
    objectives: [
      { id: 'ev', label: '2 véhicules électriques', check: (s) => countElectricVehicles(s) >= 2, target: 2, current: (s) => countElectricVehicles(s), format: 'number' },
    ],
    reward: '+ Badge "Transition énergétique" débloqué',
  },
  {
    id: 'ch-tender-king',
    name: 'Roi des marchés',
    description: 'Gagnez 3 appels d\'offres en 2 ans.',
    difficulty: 'difficile',
    icon: 'landmark',
    color: 'from-amber-500 to-orange-600',
    timeLimitDays: 720,
    objectives: [
      { id: 'ao', label: '3 AO gagnés', check: (s) => (s.tenderHistory || []).filter(e => e.outcome === 'won').length >= 3, target: 3, current: (s) => (s.tenderHistory || []).filter(e => e.outcome === 'won').length, format: 'number' },
    ],
    reward: '+ Badge "Roi des marchés" débloqué',
  },
  {
    id: 'ch-team-12',
    name: 'Grande équipe',
    description: 'Employez 12 chauffeurs en 2 ans.',
    difficulty: 'normal',
    icon: 'users',
    color: 'from-sky-500 to-sky-600',
    timeLimitDays: 720,
    objectives: [
      { id: 'drivers', label: '12 chauffeurs salariés', check: (s) => (s.drivers || []).length >= 12, target: 12, current: (s) => (s.drivers || []).length, format: 'number' },
    ],
    reward: '+ Badge "Grande famille" débloqué',
  },
  {
    id: 'ch-happy-crew',
    name: 'Employeur modèle',
    description: 'Au moins 6 chauffeurs avec une satisfaction moyenne ≥ 80 % en 1 an.',
    difficulty: 'difficile',
    icon: 'star',
    color: 'from-fuchsia-500 to-fuchsia-600',
    timeLimitDays: 360,
    objectives: [
      { id: 'crew', label: 'Au moins 6 chauffeurs', check: (s) => (s.drivers || []).length >= 6, target: 6, current: (s) => (s.drivers || []).length, format: 'number' },
      { id: 'sat', label: 'Satisfaction moyenne ≥ 80 %', check: (s) => avgDriverSatisfaction(s) >= 80, target: 80, current: (s) => avgDriverSatisfaction(s), format: 'number' },
    ],
    reward: '+ Badge "Employeur modèle" débloqué',
  },
  {
    id: 'ch-tier5-18m',
    name: 'La Cour des grands',
    description: 'Possédez un véhicule Tier 5 en 18 mois.',
    difficulty: 'difficile',
    icon: 'crown',
    color: 'from-violet-500 to-violet-600',
    timeLimitDays: 540,
    objectives: [
      { id: 'tier5', label: '1 véhicule Tier 5 en flotte', check: (s) => (s.vehicles || []).some(v => !v.isDemo && (v.tier || 1) >= 5), target: 1, current: (s) => (s.vehicles || []).filter(v => !v.isDemo && (v.tier || 1) >= 5).length, format: 'number' },
    ],
    reward: '+ Badge "Cour des grands" débloqué',
  },
  {
    id: 'ch-halfmillion-2y',
    name: 'Le Demi-million',
    description: 'Atteignez 500 000 € de trésorerie en 2 ans.',
    difficulty: 'extrême',
    icon: 'trophy',
    color: 'from-yellow-500 to-yellow-600',
    timeLimitDays: 720,
    objectives: [
      { id: 'treasury', label: 'Trésorerie ≥ 500 000 €', check: (s) => s.treasury >= 500000, target: 500000, current: (s) => s.treasury, format: 'money' },
    ],
    reward: '+ Badge "Demi-million" débloqué',
  },
  {
    id: 'ch-bootstrap-1y',
    name: 'Autofinancé',
    description: 'Atteignez 150 000 € de trésorerie en 1 an SANS aucun crédit en cours.',
    difficulty: 'difficile',
    icon: 'zap',
    color: 'from-teal-500 to-teal-600',
    timeLimitDays: 360,
    objectives: [
      { id: 'treasury', label: 'Trésorerie ≥ 150 000 €', check: (s) => s.treasury >= 150000, target: 150000, current: (s) => s.treasury, format: 'money' },
      { id: 'noloan', label: 'Aucun crédit actif (contrainte)', check: (s) => (s.credits || []).length === 0, target: 0, current: (s) => (s.credits || []).length, format: 'constraint' },
    ],
    reward: '+ Badge "Autofinancé" débloqué',
  },
];
